<script setup>
const { locale, t } = useI18n();

const accordionIndex = ref(null);

const setAccordionIndex = (index) => {
  index == accordionIndex.value ? (accordionIndex.value = null) : (accordionIndex.value = index);
};

const gallery_1 = {
  items: [
    { url: '/img/flower-union/gallery_1/anezka.jpg' },
    { url: '/img/flower-union/gallery_1/kinskych.jpg' },
    { url: '/img/flower-union/gallery_1/salmovsky.jpg' },
    { url: '/img/flower-union/gallery_1/sternbersky.jpg' },
    { url: '/img/flower-union/gallery_1/valdstejnska.jpg' },
    { url: '/img/flower-union/gallery_1/veletrzni.jpg' },
  ],
};
const gallery_2 = {
  items: [
    { url: '/img/flower-union/gallery_2/01.jpg', caption: 'Barbora Fastrová, Prsa, děti, bytosti a smetí, Ručně tkaná tapiserie z textilního odpadu 2022' },
    { url: '/img/flower-union/gallery_2/02.jpg', caption: 'Barbora Fastrová, Prsa, děti, bytosti a smetí, Ručně tkaná tapiserie z textilního odpadu 2022' },
    { url: '/img/flower-union/gallery_2/03.jpg', caption: 'Johana Pošová _ Barbora Fastrová_' },
    { url: '/img/flower-union/gallery_2/04.jpg', caption: 'Nábytek, Dřevo, použitý dřevěný nábytek,  Výroba_ Před-po (Jan Švéda, Martin Labík), Čalounění_ Overall Office a Kristýna Bratinková 2022' },
    { url: '/img/flower-union/gallery_2/05.jpg', caption: 'Nábytek, Dřevo, použitý dřevěný nábytek,  Výroba_ Před-po (Jan Švéda, Martin Labík), Čalounění_ Overall Office a Kristýna Bratinková 2022' },
    { url: '/img/flower-union/gallery_2/06.jpg', caption: 'Nábytek, Dřevo, použitý dřevěný nábytek,  Výroba_ Před-po (Jan Švéda, Martin Labík), Čalounění_ Overall Office a Kristýna Bratinková 2022' },
    { url: '/img/flower-union/gallery_2/07.jpg', caption: 'Nábytek, Dřevo, použitý dřevěný nábytek,  Výroba_ Před-po (Jan Švéda, Martin Labík), Čalounění_ Overall Office a Kristýna Bratinková 2022' },
    { url: '/img/flower-union/gallery_2/08.jpg', caption: 'Nábytek, Dřevo, použitý dřevěný nábytek,  Výroba_ Před-po (Jan Švéda, Martin Labík), Čalounění_ Overall Office a Kristýna Bratinková 2022' },
    { url: '/img/flower-union/gallery_2/09.jpg', caption: 'Prsa, děti, bytosti a smetí, Ručně tkaná tapiserie z textilního odpadu 2022' },
    { url: '/img/flower-union/gallery_2/10.jpg', caption: 'Prsa, děti, bytosti a smetí, Ručně tkaná tapiserie z textilního odpadu 2022' },
  ],
};
const gallery_3 = {
  items: [
    { url: '/img/flower-union/gallery_3/01-CHOMA.jpg' },
    { url: '/img/flower-union/gallery_3/01-CHOMA.jpg' },
    { url: '/img/flower-union/gallery_3/02-CHOMA.jpg' },
    { url: '/img/flower-union/gallery_3/03-CHOMA.jpg' },
    { url: '/img/flower-union/gallery_3/04-CHOMA.jpg' },
    { url: '/img/flower-union/gallery_3/05-CHOMA.jpg' },
    { url: '/img/flower-union/gallery_3/06-CHOMA.jpg' },
  ],
};
const gallery_4 = {
  items: [
    { url: '/img/flower-union/gallery_4/00.jpg', caption: 'Jakub Jansa' },
    { url: '/img/flower-union/gallery_4/01.jpg', caption: 'Jakub Jansa' },
    { url: '/img/flower-union/gallery_4/02.jpg', caption: 'Jakub Jansa' },
    { url: '/img/flower-union/gallery_4/03.jpg', caption: 'Jakub Jansa' },
    { url: '/img/flower-union/gallery_4/04.jpg', caption: 'Jakub Jansa' },
    { url: '/img/flower-union/gallery_4/05.jpg', caption: 'Jakub Jansa' },
    { url: '/img/flower-union/gallery_4/06.jpg', caption: 'Jakub Jansa' },
    { url: '/img/flower-union/gallery_4/07.jpg', caption: 'Jakub Jansa' },
    { url: '/img/flower-union/gallery_4/08.jpg', caption: 'Jakub Jansa' },
    { url: '/img/flower-union/gallery_4/09.jpg', caption: 'Jakub Jansa' },
  ],
};
const gallery_5 = {
  items: [
    { url: '/img/flower-union/gallery_5/01.jpg' },
    { url: '/img/flower-union/gallery_5/02.jpg' },
    { url: '/img/flower-union/gallery_5/03.jpg' },
    { url: '/img/flower-union/gallery_5/04.jpg' },
    { url: '/img/flower-union/gallery_5/05.jpg' },
    { url: '/img/flower-union/gallery_5/06.jpg' },
    { url: '/img/flower-union/gallery_5/07.jpg' },
  ],
};
const gallery_6 = {
  items: [
    { url: '/img/flower-union/gallery_6/00.jpg' },
    { url: '/img/flower-union/gallery_6/01.jpg' },
    { url: '/img/flower-union/gallery_6/02.jpg' },
    { url: '/img/flower-union/gallery_6/03.jpg' },
    { url: '/img/flower-union/gallery_6/04.jpg' },
  ],
};
const gallery_7 = {
  items: [
    { url: '/img/flower-union/gallery_7/01.jpg' },
    { url: '/img/flower-union/gallery_7/02.jpg' },
    { url: '/img/flower-union/gallery_7/03.jpg' },
    { url: '/img/flower-union/gallery_7/04.jpg' },
    { url: '/img/flower-union/gallery_7/05.jpg' },
    { url: '/img/flower-union/gallery_7/06.jpg' },
  ],
};
const gallery_8 = {
  items: [
    { url: '/img/flower-union/gallery_8/bara_johanka.jpg' },
    { url: '/img/flower-union/gallery_8/choma.jpg' },
    { url: '/img/flower-union/gallery_8/flowers_.png' },
    { url: '/img/flower-union/gallery_8/flowers.png' },
    { url: '/img/flower-union/gallery_8/hero.gif' },
    { url: '/img/flower-union/gallery_8/jan_broz_2.jpg' },
    { url: '/img/flower-union/gallery_8/jan_broz.jpg' },
    { url: '/img/flower-union/gallery_8/jansa.jpg' },
    { url: '/img/flower-union/gallery_8/kohout.jpg' },
    { url: '/img/flower-union/gallery_8/overall.jpg' },
    { url: '/img/flower-union/gallery_8/valentyna.jpg' },
  ],
};
</script>

<template>
  <div>
    <div class="mt-5">
      <div class="accordion-item">
        <div @click="setAccordionIndex(0)" class="accordion-item__label" :class="{ collapsed: 0 != accordionIndex }">
          <strong v-if="locale === 'cs'">Koncepce</strong>
          <strong v-else>Conception</strong>
        </div>
        <div :class="{ 'accordion-item__content': true, collapsed: 0 != accordionIndex }">
          <div class="accordion-item__content-inner">
            <p v-if="locale === 'cs'" class="mt-5 mb-5">
              Hlavním symbolem předsednictví se stal věneček dvanácti léčivých rostlin znázorněný na velkoformátovém, ekologicky vyrobeném koberci. Ten je umístěn na podlaze hlavního prostoru atria
              budovy, v níž se odehrávají samotná jednání Rady. Vití věnců je starobylý obyčej, a to nejen slovanský. Házení věnečků z kvítí do vody během slunovratu mělo zajistit romantickou
              budoucnost neprovdaných dívek, ztělesňovalo životní elán mládí, ale i přirozené pokračování života po opuštění rodného domova. Umělci se proto rozhodli nahradit kruh dvanácti zlatých
              hvězd z vlajky Evropské unie věnečkem dvanácti léčivých květů z různých regionů Evropy. Věneček, ve kterém se stonky jednotlivých květů vzájemně proplétají, čímž vytvářejí stále pevnější
              svazek, je gestem evropské sounáležitosti všech odlišných regionů. Jednoty, která se však nevylučuje s lokální identitou, folklorem a tradicí.
              <br />
              <br />
              Motiv květiny je navíc i ekologickým apelem, především v kontextu ruské agrese na Ukrajině a nadcházející energetické krize, jež se staly jedním z hlavních témat evropského
              předsednictví. Modré pozadí vlajky Unie tak bylo nahrazeno polem zeleným. Historie samotné vlajky Evropské unie sahá až do roku 1955, kdy existovalo Společenství výroby uhlí a oceli,
              tvořené pouze šesti členskými státy. A tak se ze žhnoucích hvězd na vzdálené obloze motiv přetransformoval do květinového společenství bzučící letní louky.
              <br />
              <br />
              Metafora věnečku ale míří i k českému národu, často tak skeptickému k velkým ideám přicházejícím zvenčí. Nahrazení vzdálených hvězd květinami je gestem, které má Čechům pomoci
              srozumitelně zprostředkovat evropskou myšlenku „jednoty v rozmanitosti“. Má jim také pomoci přiblížit téma environmentu, a to i prostřednictvím našeho vřelého a pozitivního vztahu k
              přírodě. Apeluje ale též na zodpovědnost naší země spjatou s pomyslným dosažením dospělosti, Česká republika totiž letos oslavila 18. výročí vstupu do Evropské unie. Václav Havel spolu s
              dalšími signatáři Charty 77 již v roce 1985 v takzvané Pražské výzvě vybízel k evropskému sjednocení a hovořil o Evropě ukotvené na společném duchovním základě jako o naději pro všechny
              obyvatele totalitních zemí. Tato úvaha je dnes opět aktuální, a v kontextu ruské agrese snad nejvíce od pádu totalitních režimů v roce 1989. Byl to opět Václav Havel, který hovořil o
              nutnosti obětovat část svého soukromého štěstí ve prospěch vyšších ideálů a upozorňoval na zhoršující se stav životního prostředí. Opakoval také, že to může být pouze duch Evropy, který
              zbaví českou společnost strachu z druhých. V jednom ze svých posledních rozhovorů označil, mimo jiné, i vstup Ukrajiny a Běloruska do Evropské unie jako možný budoucí vývoj Evropy.
              <br />
              <br />
              Pojem společné tkáně a splétání se objevuje i v rozměrné tapiserii, kterou pro prostor tiskových konferencí připravila Barbora Fastrová a Johana Pošová. Tapiserie, ručně utkaná z
              nastříhaného použitého textilu během šestiměsíční intenzivní práce, zobrazuje záměrně výpravným způsobem proces recyklace plastových lahví do textilního vlákna. Právě z tohoto
              recyklovaného textilního vlákna a dalších zbytkových látek jsou připraveny látky módních návrhářek Overall Office, které obě umělkyně použily na sedácích.
              <br />
              <br />
              Židle, stoly a stoličky, jež tvoří vybavení vnitřních zasedacích a čekárenských prostor Rady, jsou upravenými kusy starého a nového nábytku z ohýbaného dřeva, běžně užívaného ve střední
              Evropě. Úpravami pomocí zbytkových kusů či odřezků se jednotlivé kusy nábytku proplétají a rozrůstají, což asociuje vzájemnou provázanost a z ní plynoucí nutnost dialogu.
              <br />
              <br />
              Skupina objektů Jakuba Chomy, ve spolupráci s Tomášem Kockou Juskem a Alex Selmeci, slouží jako místo setkávání, infopoint k celému projektu, knihovna a zároveň sezení pro příchozí,
              kteří v prostoru za turnikety hlavní haly čekají na vyzvednutí někým ze zaměstnanců. Hlavní objekt připomínající monolit, který je částečně vyroben z vrstev přírodního korku, asociuje
              jednotlivé ideové a obrazové vrstvy. Choma i v dalších instalacích využívá jakousi materializovanou informaci, mezi symbolickým a skutečným objektem, ve které se do jednotlivých vrstev
              funkčního nábytku skládají v obrazech a slovech zapsané myšlenky.
              <br />
              <br />
              Projekt doprovodí i webové stránky, které – stejně jako grafickou podobu květinové vlajky – zpracovával Jan Brož. Součástí kampaně je též trojice videí. Martin Kohout pracuje s
              počítačově generovaným obrazem, který v rámci vnitřní rytmiky propojuje obraz květin plujících po hladině a proudění lidského davu. Valentýna Janů představuje trojici na sebe
              navazujících klipových hraných videí, která si pohrávají s možnostmi falešné dichotomie a hranicemi mezi dualismy, jako je soukromé a veřejné, individuální a globální či naděje a skepse,
              a naznačují, že dilemata související s těmito protiklady mohou být falešná. Hrané video Jakuba Jansy alegoricky, pohádkově a vesele prostřednictvím hlavního hrdiny – hybridu člověka a
              celeru – pomáhá překonávat skepsi na zahradní slavnosti. Humorné video zároveň diváky provede scénáři, jaké by to bylo, kdyby neexistovala Evropská unie. Kostýmy pro projekty Jakuba
              Jansy a Valentýny Janů připravil opět Overall Office, a to kombinací zbytkových látek z košil, kravat a sak a recyklovaného textilního vlákna unikátní technikou art protis, která vznikla
              v šedesátých letech minulého století v Československu.
            </p>
            <p v-else class="mt-5 mb-5">
              The main symbol of the Czech Presidency is a wreath of twelve medicinal plants, and this has been incorporated in the design of the large, ecologically-manufactured carpet installed in
              the main area of the atrium in the building where Council meetings are held. The weaving of wreaths is an ancient, not only Slavic, tradition. Young unwed women cast wreaths into the
              river during the solstice to guarantee their romantic future. This symbolised not only the vitality of youth but also the natural continuation of life after leaving one’s home hearth. In
              keeping with the main symbol for the artistic presentation of the Czech Presidency, the artists chose to replace the twelve gold stars on the EU flag with twelve medicinal plants from
              different European regions. The resulting wreath, in which the stems of each plant are twisted around those of the previous one to create a more interwoven and stronger bond, embodies a
              gesture promoting a stronger European togetherness between all of the EU’s unique and distinct regions. A union, which does not exclude local identities, folklore, or traditions.
              <br />
              <br />
              The floral motif is, however, also an ecological appeal, particularly within the context of Russia’s war on Ukraine and the approaching energy crisis, which has become one of the main
              themes of the Czech Presidency. The blue background of the flag has thus been replaced with a green one. The history of the flag of the European Union dates back to 1955, to the time of
              the European Coal and Steel Community, which had only six member states. And so the motif has been transformed from glowing stars in a distant sky to a community of flowers in a buzzing
              summer meadow.
              <br />
              <br />
              The metaphor of the wreath is also pointed at the Czech nation itself, and its tendency to be sceptical towards big ideas from outside. The substitution of flowers for the stars is a
              gesture, intended to help the Czechs to plausibly communicate the European concept of “unity in diversity”. It should also facilitate a better understanding of ecological transformation
              through the warm and positive relationship Czechs have with nature. At the same time, since the Czech Republic celebrated its eighteenth year of EU membership this year, it draws
              attention to the country’s transition into adulthood and its ensuing responsibilities. Even in the distant past, in the “Prague Appeal” of 1985, Václav Havel and other Charter 77
              signatories spoke about a Europe unified through a common spiritual foundation as of a beam of hope for all the citizens of totalitarian countries. This hope is once again very pertinent
              today and, given the current Russian aggression, maybe even the most pertinent since the fall of totalitarian countries in 1989. It was also Václav Havel who spoke about the need to
              sacrifice a part of one’s personal happiness for the benefit of higher ideals, and it was he who reminded the world of the worsening state of the environment. He also repeated that it
              can only be the “European spirit” that will help Czech society to overcome the deep-rooted fear of other people. In one of his last interviews, one of the things he mentioned was that
              the admission of Ukraine and Belarus to the European Union might be one possible future development of Europe.
              <br />
              <br />
              The themes of “a common fabric” and “interweaving” may also be found in the large tapestry made for the press room area by Barbora Fastrová and Johana Pošová. The tapestry, hand-made
              from cut pieces of second-hand textile over the course of an intensive six months, uses a deliberately epic manner to depict the process of recycling plastic bottles into textile fibres.
              The Overall Office fashion design team used these types of fibres and other residual fabrics to make the materials that Johana and Barbora employed to make the seat cushions.
              <br />
              <br />
              The chairs, tables, and stools used in the waiting areas and meeting rooms of the Council building are modified pieces of old and new furniture made from bentwood, which is a typical
              material used in Central Europe. The use of wood scraps and shavings help the individual pieces of furniture to come together, interweaving and expanding them, thus evoking the concept
              of interconnectedness and the resulting need to engage in a dialogue.
              <br />
              <br />
              The collection of objects made by Jakub Choma, in collaboration with Tomáš Kocka Jusko and Alex Selmeci, serves as a meeting place – the info-centre of the entire project – a library, as
              well as a place to sit down for visitors waiting in the area just beyond the turnstiles until they are met by a staff member. The main object, a monolithic shape partially created from
              layers of natural cork, forms an association between layers of images and ideas. Even in the other installations, Choma utilises something akin to materialised information, somewhere
              between a real and a symbolic object, in which ideas expressed in both pictures and words are inscribed in each layer of the functional furniture.
              <br />
              <br />
              The entire project is accompanied by a website which – as well as the graphical representation of the flowery flag – was designed by Jan Brož. This campaign also includes three videos.
              In the first, Martin Kohout works with a computer-generated image that uses inner rhythms to connect the image of flowers floating on a river with a flowing stream of pedestrians.
              <br />
              <br />
              The second, by Valentýna Janů, presents three connected feature clips, which play with the options of false dichotomy and the borders between dualisms, such as between private and
              public, individual and global, or hope and pessimism. The clips suggest that the dilemmas associated with these opposites may be false. Then in the third, in his staged video, Jakub
              Jansa uses allegory, a fairy-tale approach and humour to present the adventures of his protagonist – a hybrid of a man and celery – to help to overcome scepticism at a garden party. This
              humorous video also shows viewers what life would be like if there were no European Union. The costumes for the projects of both Jakub Jansa and Valentýna Janů were once again made by
              Overall Office by combining remnants left over from making shirts, ties, and evening jackets with recycled textile fibres. They utilised the unique art protis technique, which was
              developed in 1960s Czechoslovakia.
            </p>
            <div class="flowers">
              <img src="/img/flower-union/flowers.png" alt="flowers" />
              <p v-if="locale === 'cs'">
                <strong>1</strong>&nbsp;Kopretina <strong>2</strong>&nbsp;Neroli <strong>3</strong>&nbsp;Mučenka <strong>4</strong>&nbsp;Měsíček <strong>5</strong>&nbsp;Aloe Vera
                <strong>6</strong>&nbsp;Třezalka <strong>7</strong>&nbsp;Smetánka <strong>8</strong>&nbsp;Kozlík <strong>9</strong>&nbsp;Aksamitník <strong>10</strong>&nbsp;Bougainvillea
                <strong>11</strong>&nbsp;Slunečnice <strong>12</strong>&nbsp;Portulaca
              </p>
              <p v-else>
                <strong>1</strong>&nbsp;Kopretina <strong>2</strong>&nbsp;Neroli <strong>3</strong>&nbsp;Mučenka <strong>4</strong>&nbsp;Měsíček <strong>5</strong>&nbsp;Aloe Vera
                <strong>6</strong>&nbsp;Třezalka <strong>7</strong>&nbsp;Smetánka <strong>8</strong>&nbsp;Kozlík <strong>9</strong>&nbsp;Aksamitník <strong>10</strong>&nbsp;Bougainvillea
                <strong>11</strong>&nbsp;Slunečnice <strong>12</strong>&nbsp;Portulaca
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <div @click="setAccordionIndex(1)" class="accordion-item__label" :class="{ collapsed: 1 != accordionIndex }">
          <strong>Jan Brož</strong>
        </div>
        <div :class="{ 'accordion-item__content': true, collapsed: 1 != accordionIndex }">
          <div class="accordion-item__content-inner" :class="{ collapse: 1 != accordionIndex }">
            <figure class="editor">
              <div>
                <img src="/img/flower-union/jan_broz.jpg" alt="flowers" class="acordionImg mt-5 mb-5" />
              </div>
            </figure>
            <p v-if="locale === 'cs'">
              <strong>Květinová unie, květinové spojení</strong>
              <br />
              <br />
              Jan Brož vytvořil ve spolupráci s ostatními umělci projektu Květinová unie alegorické pojetí oficiální vlajky Evropské unie. Přepracování do podoby věnečku na zeleném pozadí spěje k
              úvaze nad silou přírodního světa nad tím lidským. V superschopnosti rostlin znovu se narodit pouze ze své podzemní části, se tato říše tyčí v určitém ohledu vysoko nad lidskou
              společností. Věnečkové spojení rostlin k záchraně světa se může rovnat přirozenější verzi nadpřirozeného seskupení typu Strážců vesmíru nebo Společenstva prstenu, přičemž se však v tomto
              případě nesnaží zničit prsten zla, ale naopak vytvořit květinový prstenec dobra obepínající naši planetu.
              <br />
              <br />
              Rostliny zvolené do symbolického kruhu mají proto naznačovat kombinaci vhodnou pro pomyslný čajový lektvar proti beznaději a skepsi, čajovou směs typu “Rozkvetlá louka”, v plné síle. V
              síle ovlivňující naše dějiny v nejlepším slova smyslu, v síle popínavých rostlin zakrývajících opadané omítky a díry ve zdech, síle čistící vzduch, který my dokážeme jen znečistit, síle
              vycházející z pudu sebezáchovy ekosystému, kterému se lidé často vzpírají pod vidinou moci a zisku. I přesto jsou tyto dva světy nezvratně propojené. Když padá příroda, padá i člověk.
              <br />
              <br />
              Jedna ze zobrazených květin - slunečnic - národní květina Ukrajiny - v projektu expanduje i do prezidentského salonku předsednictví, prostoru, kde probíhají ta jednání těch nejvyšších
              představitelů. Koberec s jemným vysokým vlasem tak snad bude pod jejich nohama politiky upomínat, aby na osud Ukrajiny nezapomněli.
            </p>
            <p v-else>
              <strong>Flower Union, floral connection</strong>
              <br />
              <br />
              Jan Brož, in collaboration with other artists of the Flower Union project, created an allegorical concept of the official flag of the European Union. The circle of stars transformed into
              a wreath on a green background leads to a reflection on the power of the natural world over the human one. In the superpower of plants to be reborn only from their underground part, this
              realm rises in some ways high above human society. The wreath of flowers joining together to save the world may be equivalent to a more natural version of a supernatural grouping like
              the Guardians of the Universe or the Fellowship of the Ring, but in this case it is not seeking to destroy the ring of evil, but rather to create a floral ring of goodness encircling our
              planet.
              <br />
              <br />
              The plants chosen for the symbolic circle are therefore meant to suggest a combination suitable for an imaginary tea potion against despair and scepticism, full strength of a "Flowering
              Meadow" type tea blend. The power to influence our history in the best sense of the word, the power of climbing plants to cover up fallen plaster and holes in walls, the power to purify
              the air that we can only pollute, the power that comes from the ecosystem's instinct for self-preservation, which people often resist in the name of power and profit. Yet the two worlds
              are irreversibly linked. When nature falls, man falls.
              <br />
              <br />
              One of the flowers depicted in the project - sunflower - the national flower of Ukraine - expands into the presidential lounge, the space where the meetings of the highest officials take
              place. The carpet with its fine high pile will thus hopefully remind politicians under their feet not to forget the suffering of Ukraine.
            </p>
            <figure class="editor">
              <div>
                <img src="/img/flower-union/jan_broz_2.jpg" alt="flowers" class="acordionImg mt-5 mb-5" />
              </div>
            </figure>
            <p v-if="locale === 'cs'" class="text--4 mb-5">
              <strong>Jan Brož</strong><br />
              Květinová unie<br />
              12 koberců<br />
              Spolupráce: Valentýna Janů, Overall Office, Barbora Fastrová, Jakub Choma, Jakub Jansa, Johana Pošová, Martin Kohout a Michal Novotný<br />
              Výroba: Grund CZ
            </p>
            <p v-else class="text--4 mb-5">
              <strong>Jan Brož</strong><br />
              Flower Union<br />
              12 carpets pieces<br />
              Collaboration: Valentýna Janů, Overall Office, Barbora Fastrová, Jakub Choma, Jakub Jansa, Johana Pošová, Martin Kohout, and Michal Novotný Novotný<br />
              Manufacturing: Grund CZ
            </p>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <div @click="setAccordionIndex(2)" class="accordion-item__label" :class="{ collapsed: 2 != accordionIndex }">
          <strong>Barbora Fastrová & Johana Pošová</strong>
        </div>
        <div :class="{ 'accordion-item__content': true, collapsed: 2 != accordionIndex, open: 2 === accordionIndex }">
          <div class="accordion-item__content-inner" :class="{ collapse: 2 != accordionIndex }">
            <figure class="editor">
              <div>
                <img src="/img/flower-union/bara_johanka.jpg" alt="flowers" class="acordionImg mt-5 mb-5" />
              </div>
            </figure>
            <p v-if="locale === 'cs'">
              <strong>Vzkvétání textilního odpadu</strong>
              <br />
              <br />
              Umělecké duo Pošová a Fastrová se v posledních letech své téměř desetileté spolupráce zabývá udržitelností. Ta se promítá i do tapiserie utkané z textilního odpadu. Použité látky
              pocházejí z druhé ruky a z továren, kde by byly pod označením zbytkového materiálu zlikvidovány.
              <br />
              <br />
              Výjev propsaný do tkaniny, z části ilustruje nejen samotný její vznik, ale také metamorfózu mezi člověkem, rostlinou a odpadem. Díky sebe - ilustrativnímu obsahu se do námětu vkradlo
              mimo enviromentálního apelu ještě osobnější aktuální téma autorek: mateřství a to i v alegorickém smyslu matky zem, která dává život.
              <br />
              <br />
              Ruční výroba tapisérie trvala autorkám více než šest měsíců. Začínala stříháním a splétáním proužků látky, které jsou posléze do sebe jeden po druhém na roštu zaplétány. Dílo s jeho
              rukodělnou, domácky nedokonalou estetikou vytváří funkční kontrast k čistému, odosobněnému prostoru reprezentativní haly.
              <br />
              <br />
              <br />
              <strong>Morfující nábytek</strong>
              <br />
              <br />
              Kultovní českou firmu TON, neboli Továrnu na ohýbaný nábytek, oslovily designérky na základě její silné tradice a všudypřítomnosti nejen napříč českými domácnostmi, ale i ve veřejných
              prostorách. Z části nový a z části z bazarů upcyklovaný nábytek ve spojení s odpadem z tovární výroby morfuje do tvarů a podob oživlé prorůstající flóry. Z židlí a křesel se stávají
              sošné objekty mezi výtvarným a užitým uměním. Autorky k sobě skládají různorodé kusy jako jednotlivé dílky puzzlí. Atypická skládačka je dovršena novým čalouněním - látkami utkanými
              unikátní českou technikou art protis uchopenou značkou Overall Office. Ta umožňuje kolážově kombinovat různé tvary do jedné vrstvy látky.
              <br />
              <br />
              Autorky si pohrávají i s hranicí mezi funkčním nábytkem a uměním. Některé kusy si stále udržují pohodlnou sedící funkci, jiné se díky prorůstání organických tvarů stávají již jen sochami
              k obdivu. Jednotlivé tvary zároveň podněcují a někdy i fyzicky vynucují fyzickou blízkost a dialog tváří v tvář.
              <br />
              <br />
              Projekt je tak opět připomenutím nutnosti nezapomenout na ekologická témata, které se zde fantaskně, v surreálném posunu derou i z těch nejběžnějších běžně neviditelných předmětů
              kancelářského mobiliáře - stoliček, židlí, křesel a věšáků. Zároveň poukazuje na spřízněnost s přírodou, nutnost dialogu a naslouchání, která by se neměla vyhýbat ani izolovaným
              kancelářským prostorám s vlastním udržovaným klimatem.
            </p>
            <p v-else>
              <strong>The flourishing of textile waste</strong>
              <br />
              <br />
              The artistic duo Pošová and Fastrová have been working on sustainability for the last few years of their almost decade-long collaboration. This is also reflected in the tapestry woven
              from textile waste. The fabrics used come from second-hand clothing and linens and from factories where the fabric residues would have been discarded.
              <br />
              <br />
              The scene stitched into the fabric illustrates not only its creation itself, but also the metamorphosis between man, plant and waste. Thanks to the self-illustrative content, aside the
              environmental appeal, an even more personal topic od the two artists mothers had sneaked into the depicted themes: motherhood. Also in the allegorical sense of mother earth giving life.
              <br />
              <br />
              The tapestry took the artists more than six months to be made by hand. They started by cutting and weaving strips of fabric, which are then woven together one by one on a grid. The work,
              with its handmade, homespun aesthetic, creates a functional contrast to the clean, stripped-down space of the representative hall.
              <br />
              <br />
              <br />
              <strong>Morphing furniture</strong>
              <br />
              <br />
              The iconic Czech company TON was approached by the designers based on its strong tradition and ubiquity not only across Czech households, but also in public spaces. Partly new and partly
              upcycled from second-hand stores, new and second hand furnitures morphs when combined with the waste from factory production into the shapes and forms of animated, growing flora. Chairs
              and armchairs become sculptural objects between fine and applied art. The artists put the different pieces together like individual puzzle pieces. The atypical jigsaw puzzle is completed
              with new upholstery - fabrics woven with a unique Czech art protis technique grasped by the Overall Office brand. This technique allows collage-like combination of different shapes into
              one layer of fabric.
              <br />
              <br />
              The authors also play with the boundary between functional furniture and art. Some pieces still retain a comfortable seating function, others become thanks to the increasing
              interpenetration of organic shapes mere sculptures to visually admire. At the same time, individual shapes encourage and sometimes even physically enforce physical proximity and
              face-to-face dialogue.
              <br />
              <br />
              The project is thus once again a reminder of the necessity not to forget the ecological themes, which here emerge fantastically, in a surreal shift, even from the most common, normally
              invisible objects of office furnishings - stools, chairs, armchairs and coat hangers. At the same time, it points to a kinship with nature, the necessity of dialogue and listening, which
              should not be avoided even in isolated office spaces with their own well-maintained climate.
            </p>
            <div v-if="gallery_2.items.length > 1" class="mt-5 mb-5">
              <DynamicSwipeGallery :content="gallery_2" />
            </div>
            <p v-if="locale === 'cs'" class="text--4 mb-5">
              <strong>Johana Pošová & Barbora Fastrová</strong><br />
              Prsa,děti,bytosti a smetí<br />
              Ručně tkaná tapiserie z textilního odpadu 2022
              <br />
              <br />
              <strong>Johana Pošová & Barbora Fastrová</strong><br />
              Nábytek<br />
              Dřevo, použitý dřevěný nábytek,<br />
              Výroba: Před-po (Jan Švéda, Martin Labík)<br />
              Čalounění: Overall Office a Kristýna Bratinková 2022
            </p>
            <p v-else class="text--4 mb-5">
              <strong>Johana Pošová & Barbora Fastrová</strong><br />
              Breasts, Children, Creatures, and Waste<br />
              Handmade tapestry from discarded textiles 2022
              <br />
              <br />
              <strong>Johana Pošová & Barbora Fastrová</strong><br />
              The Furniture<br />
              Bent wood, upcycled wooden furniture, textile<br />
              Manufacturing: Před–po (Jan Švéda & Martin Labík)<br />
              Upholstery: Overall Office & Kristýna Bratinková 2022
            </p>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <div @click="setAccordionIndex(3)" class="accordion-item__label" :class="{ collapsed: 3 != accordionIndex }">
          <strong>Jakub Choma</strong>
        </div>
        <div :class="{ 'accordion-item__content': true, collapsed: 3 != accordionIndex, open: 3 === accordionIndex }">
          <div class="accordion-item__content-inner" :class="{ collapse: 3 != accordionIndex }">
            <figure class="editor">
              <div>
                <img src="/img/flower-union/choma.jpg" alt="flowers" class="acordionImg mt-5 mb-5" />
              </div>
            </figure>
            <p v-if="locale === 'cs'">
              <strong>Nenáhodná spojení</strong>
              <br />
              <br />
              Jakub Choma, nachází vstupní bod svojí inspirace v motivu “meeting stone”, což je virtuální monolitický objekt z jedné známé počítačové hry. Hráči jej využívají k teleportaci svých
              virtuálních “schránek” tak jako schránek svých souputníků na konkrétní místa v herním prostoru pomocí “svolávání” daného klanu. Choma motiv využívá jako alegorii vzniku a potřeby
              kolektivu. To se promítá nejen do myšlenky Evropské unie a do kolektivu umělců projektu Květinová unie, ale také kolektivu sobě vzájemně neznámých návštěvníků kteří se na místě sloužícím
              jako čekárna před vyzvednutím, některým ze zaměstnanců rady, setkávají.
              <br />
              <br />
              Choma na tomto základě dále ohledává téma vztahu člověka a fyzických objektů, které vytvářejí základnu, platformu k setkávání se, vytváření sdílených situací. Takovým objektem je ostatně
              celá budova Evropské rady. Dílo tak není jen interaktivním uměním, ale ideálně bodem poskytujícím prostor pro nezávaznou lidskou komunikaci, společný obdiv nebo zastavení se v úvaze na
              sdílené téma.
              <br />
              <br />
              Meeting stone tvoří fyzicky vertikální hmota v nadlidské velikosti, přesahující odhadovanou výšku průměrného návštěvníka. Má několik vrstev a je částečně vyroben z přírodního korku.
              <br />
              Okolní objekty - knihovna, informační kiosek a lavičky na sezení, které vznikly ve spolupráci s Tomáš Kocka Jusko a Alex Selmeci, v různých materiálech a formách propojují a morfují
              faktické informace o výstavě, obrázky z procesu jejího vzniku i náhodné obrázky - na svém povrchu odrážejí koláž představující koncepci výstavy. Choma v celé instalaci pracuje s
              metaforou klíčení a prorůstání povrchy, škvírami a spárami, která opět odráží i politickou angažovanost stejně jako apel sahání si do svědomí.
              <br />
              <br />
              To se promítá i do laviček, které mají formu záhybu potencionálně zachytávajícího drobnosti vypadlé z kapes. Záhyb zároveň připomíná klíček z půdy se zvedajícího semínka. Motiv, který se
              objevuje i na povrchu dalšího itineráře.
              <br />
              <br />
              Posledním dílem je reliéf umístěný v místnosti vedle prezidentského salonku. Do něj se opět promítají jednotlivé motivy prezentace, slunečnice odkazující k nutnosti nezapomenout na
              ukrajinský válečný konflikt, piktogram šepotu a tvar ucha i motiv záměrné zašlé manžety košile jako formální náležitosti politických vztahů. Objekt osciluje mezi silou znaku a křehkostí
              a pomíjivostí materiálu zdůrazněnou použitím semínek a pírek.
            </p>
            <p v-else>
              <strong>Non-accidental connections</strong>
              <br />
              <br />
              Jakub Choma, finds the entry point of his inspiration in the motif of "meeting stone", which is a virtual monolithic object from a well-known computer game. Players use it to teleport
              their virtual "selfs" as well as those of their peers to specific locations in the game space by "summoning" their “clan”. Choma uses the motif as an allegory for the formation and need
              for a collective. This translates not only into the idea of the European Union and the collective of the artists of the Flower Union project, but also into the collective of mutually
              unknown visitors who meet in a place that serves as a waiting area before one is being picked up by a council employee.
              <br />
              <br />
              On this basis, Choma further reflects on the theme of the relationship between humans and physical objects, object that form a base, a platform for encounters, creating shared
              situations. The whole European Council building is such an object. The work is thus not just interactive art, but ideally a point providing a space for non-committal human communication,
              a shared admiration or a pause in reflection on a shared theme.
              <br />
              <br />
              Meeting stone is physically a vertical mass of superhuman size, exceeding the estimated height of the average visitor. It has several layers and is partially made of natural cork.
              <br />
              The surrounding objects - a library, an information kiosk and seating benches, which were created in collaboration with Tomas Kocka Jusko and Alex Selmeci, link and morph factual
              information about the exhibition, images from the process of its creation and random images in different materials and forms - reflecting on their surface a collage that represents the
              concept of the exhibition. Throughout the installation, Choma works with the metaphor of sprouting and growing through surfaces, cracks and joints, yet again reflecting political
              engagement as well as an appeal to conscience.
              <br />
              <br />
              This is also reflected in the benches, which take the form of a fold potentially catching small items that have fallen out of pockets. At the same time, the fold resembles the germ of a
              seed rising from the soil. A motif that also appears on the surface of the other itinerary.
              <br />
              <br />
              The last work is a relief placed in the room next to the presidential lounge. It again incorporates the various motifs of the presentation, the sunflower referring to the need not to
              forget the Ukrainian war conflict, the pictogram of the whisper and the shape of the ear, as well as the motif of the deliberately dingy shirt cuff as a formal requisite of political
              relations. The object oscillates between the strength of the emblem and the fragility and impermanence of the material, emphasized by the use of seeds and feathers.
            </p>
            <div v-if="gallery_3.items.length > 1" class="mt-5 mb-5">
              <DynamicSwipeGallery :content="gallery_3" />
            </div>
            <p v-if="locale === 'cs'" class="text--4 mb-5">
              <strong>Jakub Choma</strong><br />
              Meeting Point<br />
              Multimediální instalace (různé materiály)<br />
              Spolupráce: Tomáš Kocka Jusko & Alex Selmeci<br />
              2022
              <br />
              <br />
              <strong>Jakub Choma</strong><br />
              Whisper of The Endless Cycle<br />
              Různá média, UV tisk na korku, ryté plexisklo, sušená slunečnice, slunečnicová semena, pryskyřice, překližka, peří<br />
              2022
            </p>
            <p v-else class="text--4 mb-5">
              <strong>Jakub Choma</strong><br />
              Meeting Point<br />
              Multimedial installation (various materials)<br />
              Collaboration: Tomáš Kocka Jusko & Alex Selmeci<br />
              2022
              <br />
              <br />
              <strong>Jakub Choma</strong><br />
              Whisper of The Endless Cycle<br />
              Mixed media, UV print on cork, engraved plexiglass, dried sunflower, sunflower seeds, resin, plywood, feather<br />
              2022
            </p>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <div @click="setAccordionIndex(4)" class="accordion-item__label" :class="{ collapsed: 4 != accordionIndex }">
          <strong>Jakub Jansa</strong>
        </div>
        <div :class="{ 'accordion-item__content': true, collapsed: 4 != accordionIndex }">
          <div class="accordion-item__content-inner">
            <client-only>
              <figure class="editor mt-5 mb-5">
                <div class="editor-embed">
                  <div class="editor-embed__wrap">
                    <iframe
                      class="editor-embed__iframe"
                      width="960"
                      height="640"
                      src="https://www.youtube.com/embed/qW7pntg864U?vq=large"
                      frameborder="0"
                      allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                      title="flowers video"
                    ></iframe>
                  </div>
                </div>
              </figure>
            </client-only>
            <p v-if="locale === 'cs'">
              <strong>Opening Ceremony</strong>
              <br />
              <br />
              Co se děje uvnitř květinového pugétu během důležitého politického jednání? Možná, že květiny nejsou pouze dekorativní, krásné a ještě navíc krásně vonící. Co kdyby ale dokázaly být
              aktivnější a proniknout do řešení záležitostí světových rozměrů?
              <br />
              <br />
              Ve světě rostlin mají květiny svou nezastupitelnou reprezentativní a diplomatickou roli. Nyní mají dokonce svou vlastní unii, nekonečné spojení v kruhu léčivých květin. Jejich zahradní
              ceremonie k zahájení předsednictví je uvedena formou takzvané “appreciation dinner”, tedy typem slavnostní večeře, v našem světě konané pro představitele elit a médií. Podobně jako ve
              světě lidí je přizván i komik, zde v podobě Celeristy. Hybridní postavy na pomezí zeleniny a člověka.
              <br />
              <br />
              Nadpřirozená postava Vědmy, která již není schopna předvídat budoucnost, přebírá režii nad druhou částí programu a formou eko-sexuálního slavnostního rituálu aktivizuje dekorativní
              květiny. Vědma ukazuje rostlinám, že když dají pestíky a kalichy dohromady, mohou oslovit veřejnost a měnit chod věcí. Tak doufejme, že se ji schopnost vidět do budoucnosti opět vrátí.
              <br />
              <br />
              Práce je také otevřenou poctou několika dílům umělecké historie, jako je Svatba se Zemí od Annie Sprinkle nebo Výuka abecedy rostlin od Johna Baldessariho, či série fotografií od Taryn
              Simon zachycující, kytice stojící na stolech, během důležitých politických jednání.
            </p>
            <p v-else>
              <strong>Opening Ceremony</strong>
              <br />
              <br />
              What happens inside a floral puget during an important political meeting? Maybe flowers are not only decorative, beautiful and even more beautifully smelling. But what if they could be
              more proactive and get involved in issues of global proportions?
              <br />
              <br />
              In the world of plants, flowers have an irreplaceable representative and diplomatic role. Now they even have their own union, an infinite union in the circle of medicinal flowers. Their
              garden ceremony for the opening of the presidency is given in the form of what is known as an "appreciation dinner", a type of gala dinner, in our world, held for the elites and the
              media. As in the people's world, a comedian is invited, here in the form of a “Celery-man”. Hybrid characters between vegetable and human.
              <br />
              <br />
              The supernatural figure of a claivoyante, no longer able to predict the future, takes over the direction of the second part of the film, activating decorative flowers in the form of an
              eco-sexual festive ritual. The fortune teller shows the plants that by putting pistils and calyxes together they can reach out to the public and change the course of things. So hopefully
              her ability to see into the future will return.
              <br />
              <br />
              The work is also an open homage to several works of art history, such as Annie Sprinkle's Marriage to the Earth, or John Baldessari's Teaching the Alphabet of Plants, or Taryn Simon's
              series of photographs depicting bouquets standing on tables during important political meetings.
            </p>
            <div v-if="gallery_4.items.length > 1" class="mt-5 mb-5">
              <DynamicSwipeGallery :content="gallery_4" />
            </div>
            <p v-if="locale === 'cs'" class="text--4 mb-5">
              <strong>Jakub Jansa</strong><br />
              Opening Ceremony<br />
              10min, 4K video<br />
              2022<br />
              Námět a režie: Jakub Jansa<br />
              Scénář: Jakub Jansa, Dominik Dabrowski, Alice Krajčírová<br />
              DOP: Kryštof Hlůže<br />
              DOP asistent: Tomáš Merta<br />
              Střih: Sebastian Kučkovský<br />
              Hudba: Oliver Torr<br />
              Kostýmy: Overall Office (Karolína Juříková, Kristýna Nováková)<br />
              Fotografie: Iryna Drahun<br />
              Performance: Jan Kostiha, Ester Geislerová, Kamil Nábělek, Trin Alt Vajd, Markéta Vutru, Dexton Kotora, Katsuhiro Iwashita, Veronika Čechmánková, Jakub Samek, Zai Xu, Linda Vondrová,
              Rokhaya Gueye, Anita Lubadika, Adéla Sobotková, Mary Nguyen, Linh Nguyen, Agáta Hrnčířová<br />
              CGI: Matěj Martinec <br />
              Produkce: Agáta Hrnčířová<br />
              Makeup: Majda Vaverková<br />
              Maska: Eliška Pitráková<br />
              Mistr zvuku: Nicolas Atcheson<br />
              Grading: Kryštof Melka<br />
              Světla: Tomáš Prajsler<br />
              Ostřič: Mihir Khulkarmi<br />
              Kostýmy asistence: Františka Králíková<br />
              Poděkování: Plevel (Beáta Melková), DJ Bingo, Vít Svoboda, Růst Cakes, Jaroslav Gazda<br />
            </p>
            <p v-else class="text--4 mb-5">
              <strong>Jakub Jansa</strong><br />
              Opening Ceremony<br />
              10min, 4K video<br />
              2022<br />
              Director: Jakub Jansa<br />
              Script: Jakub Jansa, Dominik Dabrowski, Alice Krajčírová<br />
              DOP: Kryštof Hlůže<br />
              DOP assistant: Tomáš Merta<br />
              Editor: Sebastian Kučkovský<br />
              Music: Oliver Torr<br />
              Costumes: Overall Office (Karolína Juříková, Kristýna Nováková)<br />
              Photography: Iryna Drahun<br />
              Performance: Jan Kostiha, Ester Geislerová, Kamil Nábělek, Trin Alt Vajd, Markéta Vutru, Dexton Kotora, Katsuhiro Iwashita, Veronika Čechmánková, Jakub Samek, Zai Xu, Linda Vondrová,
              Rokhaya Gueye, Anita Lubadika, Adéla Sobotková, Mary Nguyen, Linh Nguyen, Agáta Hrnčířová<br />
              CGI: Matěj Martinec<br />
              Production: Agáta Hrnčířová<br />
              Make-up: Majda Vaverková<br />
              Mask: Eliška Pitráková<br />
              Sound master: Nicolas Atcheson<br />
              Grading: Kryštof Melka<br />
              Lights: Tomáš Prajsler<br />
              Focus puller: Mihir Khulkarmi<br />
              Costume assistant: Františka Králíková<br />
              Special thanks: Plevel (Beáta Melková), DJ Bingo, Vít Svoboda, Růst Cakes, Jaroslav Gazda
            </p>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <div @click="setAccordionIndex(5)" class="accordion-item__label" :class="{ collapsed: 5 != accordionIndex }">
          <strong>Valentýna Janů</strong>
        </div>
        <div :class="{ 'accordion-item__content': true, collapsed: 5 != accordionIndex }">
          <div class="accordion-item__content-inner">
            <client-only>
              <figure class="editor mt-5 mb-5">
                <div class="editor-embed">
                  <div class="editor-embed__wrap">
                    <iframe
                      class="editor-embed__iframe"
                      width="960"
                      height="640"
                      src="https://www.youtube.com/embed/CSnhVwrYl88"
                      frameborder="0"
                      allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                      title="flowers video"
                    ></iframe>
                  </div>
                </div>
              </figure>
            </client-only>
            <p v-if="locale === 'cs'">
              <strong>Dualismus → dilema → iluze?</strong>
              <br />
              <br />
              Valentýna Janů uvádí krátký poetický experimentální film nazvaný Flowers Between Two Fires fascinovaný jemností barev. Jednotlivé scény propojuje mimo jiné i ústřední motiv výstavy,
              květiny prostupují všemi třemi scénami v různých podobách: kulisami, v potisku oblečení jako rekvizita nebo i jen metaforicky.
              <br />
              <br />
              Ve filmu je moderátorka přinucena udělat televizní vstup na vlastní cestě domů rozkvetlým parkem. Střední část představuje podivnou schůzku mileneckého páru v muzeu, kde na pozadí
              válečného výjevu dochází k proměně dynamiky mezi oběma postavami. Závěrečná scéna filmu se odehrává na jevišti prostřednictvím postavy tanečníka představujícího znavenou labut, která se
              nemůže rozhodnout, jak její příběh skončí. Labutí jezero, balet, který je interpretován tanečními soubory po celém světě, je známý svým nejasným závěrem. Různá představení si volí jeho
              konec, někdy je proto pohádkou, jindy tragickým příběhem o lásce a zradě.
              <br />
              <br />
              Janů si pohrává s ústředním tématem dilematu způsobeného ostře danou hranicí mezi dualismy, jako je soukromé a veřejné, individuální a globální, performance a autenticita či naděje a
              skepse. Téma ambivalence prostupuje situacemi, které naznačují, že tato dichotomie je možná jen zjednodušením, uměle vytvořenou lidskou iluzí, nutící svět vymezovat se a rychle rozlišit
              mezi tím, co je dobré, a co špatné. Falešné dojmy, deziluze provází naši snahu o objektivní ohledávání globálních i osobních problémů, v dnešní postmediální době téměř neřešitelných.
              Postavy ve filmu jsou vystaveny hodnotícímu zraku světa, fiktivním sledujícím televizních zpráv, divákům v hledišti baletu, či opravdovému publiku filmu. Situace přitom odkazují na
              prostředí Evropské rady, řízené napětím z nutnosti činit jednoznačná závažná rozhodnutí na globální úrovni, bez přímého prožití daných problémů.
            </p>
            <p v-else>
              <strong>Dualism → dilemma → illusion?</strong>
              <br />
              <br />
              Valentýna Janů presents a short poetic experimental film called Flowers Between Two Fires, fascinated by the subtlety of colours. The individual scenes are connected by the central motif
              of the exhibition, flowers permeats all three scenes in various forms: as backdrops, in printed clothing as props or even just metaphorically.
              <br />
              <br />
              In the film, the presenter is forced to make a televised entrance on her own way home through a flowered park. The middle section presents a strange encounter between a lovers couple in
              a museum, where the dynamic between the two characters changes against the backdrop of a war scene. The final scene of the film takes place on stage through the figure of a dancer
              representing a tired swan who cannot decide how her story will end. Swan Lake, a ballet that is performed by dance companies around the world, is known for its ambiguous ending.
              Different performances choose its ending, making it sometimes a fairy tale, sometimes a tragic story of love and betrayal.
              <br />
              <br />
              Janů plays with the central theme of the dilemma caused by the sharply defined boundary between dualisms such as private and public, individual and global, performance and authenticity,
              or hope and skepticism. The theme of ambivalence permeates situations that suggest that this dichotomy may be a simplification, an artificial human illusion, forcing the world to define
              itself and quickly distinguish between what is good and what is bad. False impressions, disillusionment, accompany our efforts to objectively consider global and personal problems,
              almost intractable in today's post-media age. The characters in the film are subjected to the evaluative gaze of the world, the fictional watchers of television news, the audience in the
              auditorium of a ballet, or the real audience of a film. In doing so, the situations refer to the environment of the European Council, driven by the tension of having to make unequivocal
              serious decisions on a global level, without directly experiencing the issues at hand.
            </p>
            <div v-if="gallery_5.items.length > 1" class="mt-5 mb-5">
              <DynamicSwipeGallery :content="gallery_5" />
            </div>
            <p v-if="locale === 'cs'" class="text--4 mb-5">
              <strong>Valentýna Janů</strong><br />
              Flowers Between Two Fire<br />
              HD video, 8 min,<br />
              Spolu-režie: Kryštof Hlůže<br />
              Fotografie: Iryna Drahun<br />
              2022
              <br />
              <br />
              Režie & scénář: Valentýna Janů<br />
              Co-režie & kamera: Kryštof Hlůže<br />
              Střih: Katarina Gramatová<br />
              Hrají: Monina Nevrlá, Anna Agáta Denzenová, Kembe Chona, Groovy Sparks<br />
              Baletky: Eriona Bici, Gaia Finetto, Julia Marti, Alexandra Pera<br />
              Produkce: Kristýna Kapounová<br />
              Sound design: Martin Blauber, NAPA Records<br />
              Boomer: Tomáš Merta<br />
              Osvětlovač: Tomáš Prajsler<br />
              MUA: Margarita Krupenich, Groovy Sparks<br />
              Fotografka: Iryna Drahun<br />
              Speciální poděkování: Divadlo Hybernia, Haroldovo panorama, Dopravní podnik hl. města Prahy, Studio Bystrouška
              <br />
              <br />
              <strong>Valentýna Janů</strong><br />
              Leaving Home, Going Out<br />
              Foukané sklo<br />
              2022
            </p>
            <p v-else class="text--4 mb-5">
              <strong>Valentýna Janů</strong><br />
              Flowers Between Two Fire<br />
              a film by Valentýna Janů, co-directed with Kryštof Hlůže<br />
              HD video, 8 min, Photography by Iryna Drahun<br />
              2022
              <br />
              <br />
              Director & script: Valentýna Janů<br />
              Co-directed & DOP: Kryštof Hlůže<br />
              Editor: Katarina Gramatová<br />
              Starring: Monina Nevrlá, Anna Agáta Denzenová, Kembe Chona, Groovy Sparks<br />
              Ballerinas: Eriona Bici, Gaia Finetto, Julia Marti, Alexandra Pera<br />
              Production: Kristýna Kapounová<br />
              Sound design: Martin Blauber, NAPA Records<br />
              Boomer: Tomáš Merta<br />
              Gaffer: Tomáš Prajsler<br />
              MUA: Margarita Krupenich, Groovy Sparks<br />
              Photography: Iryna Drahun<br />
              Special thanks: Divadlo Hybernia, Haroldovo panorama, Dopravní podnik hl. města Prahy, Studio Bystrouška
              <br />
              <br />
              <strong>Valentýna Janů</strong><br />
              Leaving Home, Going Out<br />
              Hand blown shot glass<br />
              2022
            </p>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <div @click="setAccordionIndex(6)" class="accordion-item__label" :class="{ collapsed: 6 != accordionIndex }">
          <strong>Martin Kohout</strong>
        </div>
        <div :class="{ 'accordion-item__content': true, collapsed: 6 != accordionIndex }">
          <div class="accordion-item__content-inner">
            <client-only>
              <figure class="editor mt-5 mb-5">
                <div class="editor-embed">
                  <div class="editor-embed__wrap">
                    <iframe
                      class="editor-embed__iframe"
                      width="960"
                      height="640"
                      src="https://www.youtube.com/embed/b7KBEaSlAlM"
                      frameborder="0"
                      allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                      title="flowers video"
                    ></iframe>
                  </div>
                </div>
              </figure>
            </client-only>
            <p v-if="locale === 'cs'">
              <strong>Společný směr zdánlivě cizích osob</strong>
              <br />
              <br />
              Záměrem audiovizuálního tvůrce Martina Kohouta bylo již od počátku přinést do kolektivu umělců počin, který nebude jen sólovým dílem, ale součástí celku. Vytvořil proto dvě 3D videa
              vytvářející instalaci nazvanou Flo, která zdůrazňuje pouto vedoucí kolektiv společným směrem.
              <br />
              <br />
              První video sleduje skupinu květů plujících na hladině vody, kde občasně vytvoří kruh odkazující na ústřední motiv celého projektu vycházející ze symbolu Evropské unie. Tím, jak se květy
              při plutí poklidně houpou působí až meditativně. Ze samostatných květů se následně pod vodní hladinou splete věnec, čímž se kruh ještě upevní a dál tak zdůrazní důležitou myšlenku
              společnosti poskládané z jednotlivých prvků.
              <br />
              <br />
              Druhé 3D video, vytvořené společně s kyjevským animátorem Jurijem Kudrykem, sleduje formálně stylizovaný dav kráčející společně před kamerou. Záběr oživují mikro akce. Některé osoby jdou
              pomaleji, jiné rychleji, někdo se občas podívá do kamery, jiní telefonují. Nejsou nijak obtěžkáni předměty, jdou odhodlaně, ale bez spěchu. Cíl je neznámý. Inspirace pochází nejen z
              pochodů a protestů organizovaných řadách běžných lidí, ale i z odchodu diplomatů při videoprojevu Sergeye Lavrova ve Spojených národech na začátku okupace na Ukrajině, nebo jiných
              tichých pochodů. Tedy ze situací, kdy je i mezi téměř nebo zcela cizími lidmi jasné a silné pouto dané kontextem a atmosférou situace.
            </p>
            <p v-else>
              <strong>The common direction of seemingly strangers</strong>
              <br />
              <br />
              The intention of audiovisual creator Martin Kohout from the very beginning was to bring to the collective of artists a work that would not just be a solo piece, but part of a whole. He
              therefore created two 3D videos creating an installation called Flo, which emphasizes the bond that leads the collective in a common direction.
              <br />
              <br />
              The first video follows a group of flowers floating on the surface of the water, where they occasionally form a circle referring to the central motif of the whole project - a wreath -
              based on the symbol of the European Union. The way the flowers sway peacefully as they float gives an almost meditative effect. The individual flowers are then woven into a wreath
              beneath the water's surface, thus strengthening the circle and further emphasizing the important idea of a society made up of individual elements.
              <br />
              <br />
              The second 3D video, created together with Kiev-based animator Yuri Kudryk, follows a formally stylized crowd walking together in front of the camera. The footage is enlivened by
              micro-actions. Some people walk slower, others faster, some occasionally look into the camera, others make phone calls. They are unencumbered by objects, walking with determination but
              without haste. The destination is unknown. Inspiration comes not only from the marches and protests organized by the grassroots, but also from the video of departure of diplomats during
              Sergey Lavrov's United Nations address at the beginning of the occupation in Ukraine, or other silent marches. That is to say, from situations where there is a clear and strong bond,
              even between almost or completely strangers, given the context and atmosphere of the situation.
            </p>
            <div v-if="gallery_6.items.length > 1" class="mt-5 mb-5">
              <DynamicSwipeGallery :content="gallery_6" />
            </div>
            <p v-if="locale === 'cs'" class="text--4 mb-5">
              <strong>Martin Kohout</strong><br />
              Flo (dav)<br />
              Animovaná video smyčka, 4K<br />
              Spolupráce: Jurij Kudryk<br />
              2022
              <br />
              <br />
              <strong>Martin Kohout</strong><br />
              Flo (květy)<br />
              Animovaná video smyčka, 4K<br />
              3D shaders: Kryppers<br />
              3D asistence: Sanath Shetty, Skeno, zeroskillz<br />
              Speciální poděkování: Constantin Engelmann, Marina Hendrychová, Philipp Klein, Robbie Tilton, komunita Blender 3D<br />
              2022
            </p>
            <p v-else class="text--4 mb-5">
              <strong>Martin Kohout</strong><br />
              Flo (crowd)<br />
              Animated video loop, 4K<br />
              Collaboration: Jurij Kudryk<br />
              2022
              <br />
              <br />
              <strong>Martin Kohout</strong><br />
              Flo (blooms)<br />
              Animated video loop, 4K<br />
              3D shaders: Kryppers<br />
              3D assistance: Sanath Shetty, Skeno, zeroskillz<br />
              Special thanks: Constantin Engelmann, Marina Hendrychová, Philipp Klein, Robbie Tilton, Blender 3D community<br />
              2022
            </p>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <div @click="setAccordionIndex(7)" class="accordion-item__label" :class="{ collapsed: 7 != accordionIndex }">
          <strong>Overall Office</strong>
        </div>
        <div :class="{ 'accordion-item__content': true, collapsed: 7 != accordionIndex }">
          <div class="accordion-item__content-inner">
            <figure class="editor">
              <div>
                <img src="/img/flower-union/overall.jpg" alt="flowers" class="acordionImg mt-5 mb-5" />
              </div>
            </figure>
            <p v-if="locale === 'cs'">
              <strong>Neformálnost ve světě květin</strong>
              <br />
              <br />
              Karolína Juříková a Kristýna Nováková prostupují jménem slow fashion značky Overall Office vícero částmi celého projektu v podobě oděvů a textilií barevně i tvarově inspirovaných
              rozmanitou říší květin.
              <br />
              <br />
              Ve videu Jakuba Jansy se státnický šatník prolíná s fyziognomií květin a z obou světů si bere jejich nejzásadnější znaky. Politická formálnost se kombinuje s přírodní rozjíveností, ale i
              jednoduchou naivní papundeklovostí dětských teelvizních pořadů. Na personifikovaných postavách květin šaty pučí, kvetou i uvadají. Celerista stylizovaný do role stand-up komika ve fraku
              a jeho matka, mystičtější celerovitá Vědma v rašícím světlém hábitu doplněném podobně hábitovitými broskvovými šaty s měděným efektem.
              <br />
              <br />
              Druhý oděvní vstup Overall Office míří do videa Valentýny Janů, aby propojil odění a svět květin jakožto leitmotif všech třech částí filmu, ale také kostýmu s kulisami scény. Kabát s
              květy růží splývá s petřínskou růžovou zahradou, červené sako hlasatelky je pak parafrází formalniho moderátorského oděvu. Je vytvořené z autorské textilie unikátní československou
              technikou art protis, používanou obvykle pro tvorbu netkaných nástěnných koberců. Technika se promítá také do nábytkové a objektů dvojice Pošová & Fastrová.
              <br />
              <br />
              Pohotový způsob výroby autorské textilie pohltil monotónní oděvy nošené v Evropském parlamentu, jako jsou košile, saka i kravaty, a proměnil je do podoby svéhlavých květů. Vysílají tak
              pozitivní zprávu v podobě skryté naděje pro životní prostředí, denně výrazně negativně ovlivněného právě výrobou nového oblečení ve fast fashion prostředí.
            </p>
            <p v-else>
              <strong>Informality in the world of flowers</strong>
              <br />
              <br />
              On behalf of the slow fashion brand Overall Office, Karolína Juříková and Kristýna Nováková permeate several parts of the project in the form of garments and textiles inspired by the
              diverse realm of flowers in color and shape.
              <br />
              <br />
              In Jakub Jansa's video, the statesmanlike wardrobe intertwines with the physiognomy of flowers, taking their most essential features from both worlds. The political formality is combined
              with the natural exuberance, but also with the simple naive parroting of children's TV shows. On the personified figures of flowers, dresses bud, bloom and fade. The Celerist, styled as
              a stand-up comedian in a tailcoat, and his mother, the more mystical Celerian Fortune Teller, in a flowered pale robe complemented by a similarly copper-effect peach dress.
              <br />
              <br />
              Overall Office's second clothing entry heads into Valentina Janů's video to link the clothing and the world of flowers as a leitmotif for all three parts of the film, as well as the
              costume with the set of the scene. The rose-blossom coat merges with the rose garden of Petřín, while the red jacket of the presenter is a paraphrase of the formal presenter's attire. It
              is made of the author's fabric using a unique Czechoslovak technique of art protis, usually used for creating non-woven wall carpets. The technique is also reflected in the furniture and
              objects by the duo Pošová & Fastrová.
              <br />
              <br />
              The artist's fast-paced method of fabrication absorbed the monotonous garments worn in the European Parliament, such as shirts, jackets and ties, and transformed them into the form of
              wilful flowers. They thus send a positive message in the form of a hidden hope for the environment, which is daily affected by the production of new clothes in a fast-fashion
              environment.
            </p>
            <div v-if="gallery_7.items.length > 1" class="mt-5 mb-5">
              <DynamicSwipeGallery :content="gallery_7" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5">
      <div v-if="gallery_8.items.length > 1">
        <!-- <DynamicSwipeGallery :content="gallery_8" /> -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.flowers {
  margin: 80px 0;

  img {
    width: 100%;
    max-width: 378px;
    height: auto;
    display: block;
    margin: 80px auto 50px auto;
  }
  p {
    text-align: center;
  }
}

.accordion-item {
  padding: 15px 0px;
  border-bottom: 1px solid $black;

  &:first-child {
    border-top: 1px solid $black;
  }

  &__label {
    position: relative;
    cursor: pointer;
    user-select: none;
    padding-left: 5px;

    &:focus {
      outline: 0;
    }

    &:before,
    &:after {
      background: $black;
      content: '';
      display: block;
      height: 14px;
      position: absolute;
      margin-top: -9px;
      right: 17px;
      top: 50%;
      transform-origin: 100% 100%;
      transition: transform 300ms;
      width: 1px;
    }
    &:before {
      transform: translateY(-9px) rotate(-135deg);
    }
    &:after {
      transform: translateY(-9px) rotate(135deg);
    }

    &.collapsed {
      &:before {
        transform: rotate(-45deg);
      }
      &:after {
        transform: rotate(45deg);
      }
    }
  }

  &__content-inner {
    padding: 25px 5px 0px 5px;
  }
}

.acordionImg {
  // object-fit: contain;
  width: 100%;
  height: auto;
}

.accordion-item__content {
  &.collapsed {
    max-height: 0;
    overflow: hidden;
    transition-duration: 350ms;
  }
}
</style>
